/**
 * Exported function to register the template
 * 
 * @param {PopupRenderer} renderer static PopupRenderer class
 * 
 * @memberof vef.map.popup.templates
 */
export function lto(renderer) {
    renderer.registerTemplate('lto_popup', `
| {setTitle(properties.time_series)} | |
|--|--|
| Start Date | {properties.start_date} |
| Information | [{properties.information}]({properties.information}) |
| Institute | {properties.institute} |
| Principal Investigator | {properties.principal_investigator} |
| Ocean Region | {properties.ocean_region} |
| Contact | [{properties.contact}]({properties.contact}) |
`);

renderer.registerTemplate('lto_sidebar', `
| {setTitle(properties.time_series)} | |
|--|--|
| Start Date | {properties.start_date} |
| Information | [{properties.information}]({properties.information}) |
| Institute | {properties.institute} |
| Principal Investigator | {properties.principal_investigator} |
| Ocean Region | {properties.ocean_region} |
| Contact | [{properties.contact}]({properties.contact}) |

{lto(properties.lat, properties.lng)}
`);
}